import { Grid, Divider } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import contratacao from "../../assets/contratacao.png";
import ButtonComponent from "../../components/ButtonComponent";

function ContratacaoTelemedicina() {
  const navigate = useNavigate();

  const [sizeWindow, setSizeWindow] = useState();

  useEffect(() => {
    const largura = window.screen.width;
    setSizeWindow(largura);
  }, []);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <div
            style={{
              backgroundColor: "#86BFC6",
              color: "#ffffff",
              padding: "2em",
              borderRadius: "7px",
              height: "100%",
            }}
          >
            <h2>Ah, não! </h2>
            <h3>Seu plano não possui telemedicina contratada!</h3>
            <p>
              Não tem problema, vamos te ajudar a mudar isso, contrate já nosso
              plano Família.
            </p>
            <div style={{ textAlign: "center" }}>
              <img src={contratacao} alt="Contratacao" />
            </div>
          </div>
        </Grid>
        <Grid item sm={6} xs={12}>
          <div
            style={{
              width: sizeWindow < 1000 ? "100%" : "80%",
              margin: "auto",
              padding: "3em",
              borderRadius: "7px",
            }}
          >
            <div
              style={{
                fontSize: 20,
                margin: 0,
                textAlign: "center",
              }}
            >
              Plano <b style={{ color: "#86BFC6" }}>Família</b> <br />
              com <b style={{ color: "#86BFC6" }}>Telemedicina</b>
            </div>
            <h4 style={{ fontSize: "14px", fontWeight: "normal" }}>
              Faça consultas com a nossa{" "}
              <b style={{ color: "#86BFC6" }}>Telemedicina ilimitada</b> de
              qualquer lugar a qualquer momento
            </h4>

            <h4 style={{ fontSize: "14px", fontWeight: "normal" }}>
              Cadastre seus dependentes{" "}
              <b style={{ color: "#86BFC6" }}> sem custo adicional</b>, todos
              podem desfrutar dos benefícios do aplicativo e a telemedicina (Até
              7 dependentes)
            </h4>
            <h4 style={{ fontSize: "14px", fontWeight: "normal" }}>
              Consultas médicas presenciais e exames laboratoriais com{" "}
              <b style={{ color: "#86BFC6" }}>descontos exclusivos</b> do App
            </h4>
            <div style={{ fontSize: "14px" }}>
              <Divider />
              <div style={{ textAlign: "center" }}>
                <>
                  <div style={{ fontSize: 20, margin: 0 }}>
                    Valor <b style={{ color: "#86BFC6" }}>Mensal</b>
                  </div>
                  R$<b style={{ fontSize: 30, color: "#86BFC6" }}>69,90</b>/mês
                  <h5 style={{ margin: 0, fontWeight: "normal" }}>
                    (Até 7 Dependentes*)
                  </h5>
                </>
              </div>
              <br />
              <ButtonComponent
                type="submit"
                fullWidth
                onClick={() => navigate("/app/assinatura")}
              >
                CONTRATAR ESSE PLANO
              </ButtonComponent>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default ContratacaoTelemedicina;
